// extracted by mini-css-extract-plugin
export default {"detailsWrapper":"styles_detailsWrapper__0ktNj","item":"styles_item__Pk1iE"};